import { Injectable } from '@angular/core';
import { AngularFirestore } from 'angularfire2/firestore';
import 'rxjs/add/operator/map';
import * as firebase from 'firebase';
import { HttpParams, HttpClient } from '@angular/common/http';
import { Globals } from '../../globals';

@Injectable()
export class ArticlesServices {

  public firestore: any;
  public articles_searchbar_text: string = '';
  public get_articles: boolean = false;
  public articles_array_tmp: any = [];
  public articles_array_filtered: any = [];
  public list_dishes_products_array: any = [];
  public show_articles_basic: boolean = true;
  public show_articles_foodcost: boolean = true;

  constructor(public afs: AngularFirestore,
    public http: HttpClient,
    public globals: Globals) {
    this.firestore = firebase.firestore();
  }

  async getPagesArticles(loader) {
    this.get_articles = loader;
    const params = new HttpParams()
      .set('uid', this.globals.restaurant_uid)
      .set('tax', this.globals.RESTAURANT_TAX.toString());

    await this.http.post(this.globals.analytics_path + 'paginate/dishes_products_v2', params, {})
      .subscribe(async res => {
        this.articles_array_tmp = res['list'];
        if (this.articles_array_tmp.length != 0) {
          this.getListDishesProductsMinMax();
        } else {
          this.get_articles = true;
        }
      });
  }

  getListDishesProductsMinMax() {
    this.get_articles = true;

    //Ordenamos el array
    this.articles_array_tmp.sort((a, b) => this.globals.nameLangSelectDish(a).localeCompare(this.globals.nameLangSelectDish(b)));

    //For para poner en activo los platos que puede ver el free.
    this.articles_array_tmp.forEach((value, index) => {
      value._active = true;
      if (index >= this.globals.checkLimitsByLicense('dishes', 'max_dishes') && this.globals.checkLimitsByLicense('dishes', 'max_dishes') != -1) {
        value._active = false;
      }
    });
    this.list_dishes_products_array = this.articles_array_tmp;
    this.articles_array_filtered = this.articles_array_tmp;
    this.articleSearch(this.articles_searchbar_text);
  }

  articleSearch(value) {
    if (value) {
      if (value != 'Sin categoria') {
        this.articles_array_filtered = this.list_dishes_products_array.filter(objeto => {
          return this.globals.objectToArray(objeto).some(valor => {
            if (typeof valor === 'string' || typeof valor === 'number') {
              // Comparar como string
              return valor.toString().toLowerCase().includes(value.toLowerCase());
            } else if (Array.isArray(valor)) {
              // Buscar en cada elemento del array
              return valor.some(elemento => elemento.toString().toLowerCase().includes(value.toLowerCase()));
            }
            return false;
          });
        });
      } else {
        this.articles_array_filtered = this.list_dishes_products_array.filter(objeto => {
          if (objeto.tags == undefined || objeto.tags.length == 0) {
            return true;
          }
          return false;
        });
      }
    } else {
      this.articles_array_filtered = this.list_dishes_products_array;
    }
    this.filter(true);
  }

  async duplicateArticle(article) {
    try {
      const originalData = await this.getArticleData(article);
      if (!originalData) return;

      const duplicatedData = this.createDuplicatedArticle(originalData, article.type);
      const docRef = await this.saveDuplicatedArticle(duplicatedData, article.type);
      
      this.addToFilteredArray(docRef.id, duplicatedData, article.type);
      this.trackDuplicateAction(article.type, duplicatedData);
      
    } catch (error) {
      console.error('Error duplicating article:', error);
    }
  }

  private async getArticleData(article) {
    if (article.type === 'dish') {
      return await this.getDish(article.UID);
    } else {
      return await this.getProduct(article.UID);
    }
  }

  private createDuplicatedArticle(originalData, type) {
    const baseData = {
      UID_RESTAURANT: originalData.UID_RESTAURANT,
      aiAttempts: 0,
      allergens: originalData.allergens || [],
      created_at: new Date(),
      featured: originalData.featured || false,
      image: originalData.image || '',
      observations: originalData.observations || '',
      pos_favourite: originalData.pos_favourite || false,
      tags: originalData.tags || [],
      tags_static: originalData.tags_static || '',
      tk_active: originalData.tk_active || false,
      tpv_active: originalData.tpv_active !== undefined ? originalData.tpv_active : true,
      updated_at: new Date(),
      updated_user: this.globals.user_name,
      variations_favourite: originalData.variations_favourite || [],
      pos_background_color: originalData.pos_background_color || '',
      pos_border_color: originalData.pos_border_color || '',
      tax: originalData.tax || this.globals.RESTAURANT_TAX
    };

    if (type === 'dish') {
      return {
        ...baseData,
        ...this.getDishSpecificData(originalData)
      };
    } else {
      return {
        ...baseData,
        ...this.getProductSpecificData(originalData)
      };
    }
  }

  private getDishSpecificData(dish) {
    return {
      description_ca: dish.description_ca || '',
      description_de: dish.description_de || '',
      description_en: dish.description_en || '',
      description_es: dish.description_es || '',
      description_fr: dish.description_fr || '',
      description_it: dish.description_it || '',
      foodcost: dish.foodcost || [],
      foodcost_parts: dish.foodcost_parts || 1,
      foodcost_static: dish.foodcost_static || 0,
      name_ca: dish.name_ca + ' (copy)',
      name_de: dish.name_de + ' (copy)',
      name_en: dish.name_en + ' (copy)',
      name_es: dish.name_es + ' (copy)',
      name_fr: dish.name_fr + ' (copy)',
      name_it: dish.name_it + ' (copy)',
      nutrition_100_carbohydrate: dish.nutrition_100_carbohydrate || '',
      nutrition_100_energy: dish.nutrition_100_energy || '',
      nutrition_100_fat: dish.nutrition_100_fat || '',
      nutrition_100_fiber: dish.nutrition_100_fiber || '',
      nutrition_100_protein: dish.nutrition_100_protein || '',
      nutrition_100_salt: dish.nutrition_100_salt || '',
      nutrition_100_saturate: dish.nutrition_100_saturate || '',
      nutrition_100_sugar: dish.nutrition_100_sugar || '',
      nutrition_portion_carbohydrate: dish.nutrition_portion_carbohydrate || '',
      nutrition_portion_energy: dish.nutrition_portion_energy || '',
      nutrition_portion_fat: dish.nutrition_portion_fat || '',
      nutrition_portion_fiber: dish.nutrition_portion_fiber || '',
      nutrition_portion_protein: dish.nutrition_portion_protein || '',
      nutrition_portion_salt: dish.nutrition_portion_salt || '',
      nutrition_portion_saturate: dish.nutrition_portion_saturate || '',
      nutrition_portion_sugar: dish.nutrition_portion_sugar || '',
      price: dish.price || 0,
      price_combo_extra: dish.price_combo_extra || 0,
      price_half: dish.price_half || 0,
      price_supplement: dish.price_supplement || 0,
      price_takeaway: dish.price_takeaway || 0,
      price_tapa: dish.price_tapa || 0,
      recipe: dish.recipe || '',
      time: dish.time || '',
      tools: dish.tools || '',
      traces: dish.traces || '',
      type_unit: dish.type_unit || 'ud',
    };
  }

  private getProductSpecificData(product) {
    return {
      description_ca: product.description_ca || '',
      description_de: product.description_de || '',
      description_en: product.description_en || '',
      description_es: product.description_es || '',
      description_fr: product.description_fr || '',
      description_it: product.description_it || '',
      ean: product.ean || '',
      measurement: product.measurement || 'ud.',
      name: product.name + ' (copy)',
      name_ca: product.name_ca + ' (copy)',
      name_de: product.name_de + ' (copy)',
      name_en: product.name_en + ' (copy)',
      name_fr: product.name_fr + ' (copy)',
      name_it: product.name_it + ' (copy)',
      pos_color_name: product.pos_color_name || '',
      price_static: product.price_static || 0,
      provider_static: product.provider_static || '',
      providers: product.providers || [],
      pvp: product.pvp || 0,
      pvp2: product.pvp2 || 0,
      pvp3: product.pvp3 || 0,
      pvp_combo_extra: product.pvp_combo_extra || 0,
      pvp_supplement: product.pvp_supplement || 0,
      pvp_takeaway: product.pvp_takeaway || 0,
      stock: product.stock || 0,
      stock_alert: product.stock_alert || 0,
      stock_max: product.stock_max || 0,
      sub_recipe: product.sub_recipe || false,
    };
  }

  private async saveDuplicatedArticle(data, type) {
    const collection = type === 'dish' ? 'dish' : 'products';
    return await this.firestore.collection(collection).add(data);
  }

  private addToFilteredArray(docId, data, type) {
    const commonFields = {
      UID: docId,
      allergens: data.allergens,
      image: data.image,
      name_ca: data.name_ca,
      name_de: data.name_de,
      name_en: data.name_en,
      name_es: data.name_es || data.name,
      name_fr: data.name_fr,
      name_it: data.name_it,
      pos_favourite: data.pos_favourite,
      pos_background_color: data.pos_background_color,
      pos_border_color: data.pos_border_color,
      tags: data.tags,
      tpv_active: data.tpv_active,
      _active: true,
      tax: data.tax || this.globals.RESTAURANT_TAX
    };

    const specificFields = type === 'dish' ? {
      foodcost_parts: data.foodcost_parts,
      foodcost_static: data.foodcost_static,
      price: data.price,
      type: 'dish'
    } : {
      foodcost_parts: 1,
      foodcost_static: data.price_static,
      price: data.pvp || data.price,
      type: 'product'
    };

    const newArticle = { ...commonFields, ...specificFields };
    this.articles_array_filtered.push(newArticle);
    this.articles_array_filtered.sort((a, b) => 
      this.globals.nameLangSelectDish(a).localeCompare(this.globals.nameLangSelectDish(b))
    );
  }

  private trackDuplicateAction(type, data) {
    const trackingData = type === 'dish' ? {
      category: 'Dish',
      action: 'Dish - Duplicate',
      label: 'Duplicate dish',
      value: this.globals.nameLangSelectDish(data)
    } : {
      category: 'Products',
      action: 'Products - Duplicate',
      label: 'Duplicate product',
      value: this.globals.nameLangSelectProduct(data)
    };

    this.globals.GAtrackView(
      trackingData.category,
      trackingData.action,
      this.globals.restaurant.email,
      'Duplicate',
      trackingData.label,
      trackingData.category,
      trackingData.value
    );
  }

  async getDish(uid) {
    const dishRef = this.firestore.collection('dish').doc(uid);
    var _dish;
    await dishRef.get().then(doc => {
      if (doc.exists) {
        _dish = doc.data();
        _dish.UID = doc.id;
      }
    });
    return _dish
  }

  async getProduct(uid) {
    const productRef = this.firestore.collection('products').doc(uid);
    var _product;
    await productRef.get().then(doc => {
      if (doc.exists) {
        _product = doc.data();
        _product.UID = doc.id;
      }
    });
    return _product
  }

  async getAllArticles() {
    const params = new HttpParams()
      .set('uid', this.globals.restaurant_uid)
      .set('tax', this.globals.RESTAURANT_TAX.toString());
    return await this.http.post(this.globals.analytics_path + 'paginate/dishes_products_v2', params, {}).toPromise();
  }

  filter(from_search = false) {
    var _array = this.list_dishes_products_array;
    if (from_search) {
      _array = this.articles_array_filtered;
    }

    this.articles_array_filtered = _array.filter(element => {
      if (this.show_articles_basic && element.type === "product") {
        return true;
      }
      if (this.show_articles_foodcost && element.type === "dish") {
        return true;
      }
      return false;
    });
  }
}


// WEBPACK FOOTER //
// ./src/pages/articles/services.ts